var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilter2 = function SvgFilter2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 8,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M5.333 8h1.334c.366 0 .666-.3.666-.667 0-.366-.3-.666-.666-.666H5.333c-.366 0-.666.3-.666.666s.3.667.666.667M0 .667c0 .366.3.666.667.666h10.666c.367 0 .667-.3.667-.666S11.7 0 11.333 0H.667C.3 0 0 .3 0 .667m2.667 4h6.666c.367 0 .667-.3.667-.667s-.3-.667-.667-.667H2.667C2.3 3.333 2 3.633 2 4s.3.667.667.667"
  })));
};
export default SvgFilter2;